export default {
	
}


// WEBPACK FOOTER //
// ./src/story/getters.js